import { render, staticRenderFns } from "./SkeletonSlug.vue?vue&type=template&id=7de7250a&scoped=true&"
import script from "./SkeletonSlug.vue?vue&type=script&lang=js&"
export * from "./SkeletonSlug.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonSlug.vue?vue&type=style&index=0&id=7de7250a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de7250a",
  null
  
)

export default component.exports